var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('p',{staticClass:"_margin-bottom-0"},[_vm._v("Total savings: "),_c('b',[_vm._v(_vm._s(_vm._f("currency")(_vm.savings,0)))])])])]),_c('apexchart',{attrs:{"type":"line","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }